import React from 'react';
const coverage = [{
  label: 'Every week',
  body: 'A Week Card with the whole class at a glance, in 30, 45 and 55-minute versions'
}, {
  label: 'Every block',
  body: 'Counts in 8s, 3–4 short cues, easy and hard versions, the common error and its fix'
}, {
  label: 'Music',
  body: 'BPM and structure only — teach it to any playlist you are licensed to play'
}, {
  label: 'Mixed rooms',
  body: 'A first-timer lane on every Week Card, so newcomers know where to stand and what to do'
}, {
  label: 'Zones',
  body: 'Thighs, seat, arms, core and combos, with a new warm-up and cooldown every month'
}, {
  label: 'Format',
  body: 'Landscape pages that read on a phone mid-class or print for the studio'
}];
const steps = ['Open the week', 'Pick your length', 'Press play at the BPM', 'Teach'];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-plum-mid" data-id="element-217" data-mp="1pol7lpg14kqs">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-218" data-mp="1b063chfmlnx9">
        <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-219" data-mp="1f1r9zl1kh5z0">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-semibold text-white text-3xl sm:text-5xl" data-id="element-220" data-mp="1jukd64he068z">
          The 52-Week Barre Map
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-221" data-mp="s34v8nqrz7p3">
          A full year of classes, ordered week by week with a focus and a
          progression. Every class is built from{' '}
          <span className="font-semibold text-white" data-id="element-222" data-mp="11201fzttkhse">Plug-and-Teach Blocks</span>:
          choreography written in 8-counts that plugs into any song at the
          tempo on the page.
        </p>

        <ol className="mx-auto mt-8 flex max-w-3xl flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-223" data-mp="2ch54j4xv4icj">
          {steps.map((step, i) => <li key={step} className="flex items-center gap-2 sm:gap-3" data-id="element-224" data-mp="2hiufkkl34w0m" data-mpi={i}>
              <span className="rounded-full bg-gold/15 px-4 py-2 text-[13px] font-semibold text-gold-hover" data-id="element-225" data-mp="1rr198vovz7bt">
                <span className="mr-1.5 font-display italic" data-id="element-226" data-mp="1mvvmjunntomo">{i + 1}.</span>
                {step}
              </span>
              {i < steps.length - 1 && <span className="hidden h-px w-5 bg-gold/50 sm:block" data-id="element-227" data-mp="1wt0e6a09ycav" />}
            </li>)}
        </ol>

        <ul className="mt-9 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-228" data-mp="192nvc43hqv5i">
          {coverage.map(item => <li key={item.label} className="rounded-xl border border-plum-line bg-white/5 px-4 py-3" data-id="element-229" data-mp="141gqodwnac32">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-gold" data-id="element-230" data-mp="1e0fxrs1rhzny">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-231" data-mp="q9k04eamka8s">
                {item.body}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}